export default "__VITE_ASSET__bkDThOtAcPH4b6$FLK1sBg__"